import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CategorieArticle } from '../../../facturation/shared/classes/categorie-article';
import { ArticleService } from '../../../facturation/shared/services/article.service';
import { TRANSLATE } from '../../classes/translatable';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-admin-list-article-categorie',
  templateUrl: './admin-list-article-categorie.component.html',
  styleUrls: ['./admin-list-article-categorie.component.css']
})
export class AdminListArticleCategorieComponent implements OnInit {

    lstPays: any[];
    newCategorie = new CategorieArticle({});
    selected = new FormControl(0);

    @Input() categories: CategorieArticle[] = [];
    @Output() changeCategorie: EventEmitter<CategorieArticle> = new EventEmitter();

    constructor(
        private articleService: ArticleService,
        private alertService: AlertService
    ) { }

    ngOnInit() {}

    getCategories() {
        this.articleService.getCategorieList()
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.categories = [];
                    retour.data.forEach(element => {
                        this.categories.push(new CategorieArticle(element));
                    });
                }
            });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1 && this.categories.length <= 0) { 
            this.getCategories();
        }
    }

    insertCategorie(cat: CategorieArticle) {
        this.articleService.insertCategorie(cat)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.newCategorie = new CategorieArticle({});
                    this.alertService.success(TRANSLATE('Catégorie ajoutée avec succès'));
                    this.changeCategorie.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    updateCategorie(cat: CategorieArticle) {
        this.articleService.updateCategorie(cat.aca_id, cat)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Catégorie modifiée avec succès'));
                    this.changeCategorie.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    deleteCategorie(cat: CategorieArticle) {
        this.articleService.deleteCategorie(cat.aca_id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Catégorie supprimée avec succès'));
                    this.changeCategorie.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

}
